import * as React from 'react';
import * as _ from 'underscore';

import { IGlob } from '../../ts/Glob';
//import { CSSTransition, TransitionGroup } from 'react-transition-group'; // See Issue 93537.
import { Notification } from './Notification';

export function Notifications(props: { glob: IGlob }) {
    const { notifications } = props.glob.NotificationsStore.useSimpleStoreStateHook();

    if (!Array.isArray(notifications) || notifications.length === 0) {
        return null;
    }

    return (
        <div className="platform-notifications">
            {notifications.map((notification) => {
                if (notification.widgetRunTimeID != null) {
                    return;
                }

                if (notification.options?.showInPopup || notification.options?.remainder) {
                    return;
                }

                return (
                    <Notification
                        key={'notification-' + notification.id}
                        id={notification.id}
                        value={notification}
                        glob={props.glob}
                    />
                );
            })}
            {/* <TransitionGroup>
                {_.map(notifications, (notification) => {
                    if (notification.widgetRunTimeID != null) {
                        return;
                    }

                    if (notification.options != null && notification.options.showInPopup) {
                        return;
                    }

                    return (
                        <CSSTransition
                            key={'transition-' + notification.id}
                            classNames="platform-notification"
                            timeout={{ enter: 300, exit: 300 }}
                        >
                            <Notification id={notification.id} value={notification} glob={props.glob} />
                        </CSSTransition>
                    );
                })}
            </TransitionGroup> */}
        </div>
    );
}
